import { render } from "./BannersSection.vue?vue&type=template&id=6e344668&scoped=true"
import script from "./BannersSection.vue?vue&type=script&lang=js"
export * from "./BannersSection.vue?vue&type=script&lang=js"

import "./BannersSection.vue?vue&type=style&index=0&id=6e344668&scoped=true&lang=scss"
import "./BannersSection.vue?vue&type=style&index=1&id=6e344668&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e344668"]])

export default __exports__